import { render } from "./CustomerRegist.vue?vue&type=template&id=1a1f33a1&scoped=true"
import script from "./CustomerRegist.vue?vue&type=script&lang=js"
export * from "./CustomerRegist.vue?vue&type=script&lang=js"

import "./CustomerRegist.vue?vue&type=style&index=0&id=1a1f33a1&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1f33a1"]])

export default __exports__